const preset = (state = "1", action) => {
    switch (action.type) {
        case 'SELECT_PRESET':
            return action.preset
        default :
            return state
    }
}

export default preset

